import React from 'react';
import sanitizeHtml from 'sanitize-html';
import type { IOptions as SanitizeHtmlOptions } from 'sanitize-html';

/** Editör/CMS’den gelen başlıkta <br>, <span class>, <b class> vb. güvenli biçimde */
export const CMS_SECTION_TITLE_HTML: SanitizeHtmlOptions = {
  allowedTags: ['br', 'span', 'strong', 'em', 'b', 'i'],
  allowedAttributes: {
    span: ['class'],
    b: ['class'],
  },
};

/** Metinde HTML etiketi var mı (düz metin ile ayrım) */
export function titleLooksLikeMarkup(s: string): boolean {
  return /<\/?[a-z][\s\S]*?>/i.test((s ?? '').trim());
}

/**
 * Düz metin: \\n ile satır ve orta satır vurgusu (React node).
 * HTML string (CMS): sanitize edilmiş DOM olarak render.
 */
export function renderCmsSectionTitle(title: string): React.ReactNode {
  const raw = title ?? '';
  if (titleLooksLikeMarkup(raw)) {
    return (
      <span
        className="contents"
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(raw, CMS_SECTION_TITLE_HTML),
        }}
      />
    );
  }

  const parts = raw
    .split('\n')
    .map((s) => s.trim())
    .filter(Boolean);
  if (parts.length >= 3) {
    return (
      <>
        {parts[0]}
        <br />
        <span className="font-display text-alsero-first">{parts[1]}</span> {parts.slice(2).join(' ')}
      </>
    );
  }
  if (parts.length === 2) {
    return (
      <>
        {parts[0]}
        <br />
        <span className="font-display text-alsero-first">{parts[1]}</span>
      </>
    );
  }
  return raw;
}
